var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertifications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3975 10.7422L14.66 17.8472C14.6742 17.9309 14.6624 18.0168 14.6264 18.0936C14.5903 18.1705 14.5317 18.2344 14.4583 18.277C14.3849 18.3196 14.3003 18.3388 14.2157 18.3319C14.1311 18.3251 14.0507 18.2926 13.985 18.2389L11.0017 15.9997C10.8577 15.8921 10.6827 15.834 10.503 15.834C10.3232 15.834 10.1482 15.8921 10.0042 15.9997L7.01587 18.238C6.9503 18.2917 6.86992 18.3241 6.78545 18.331C6.70098 18.3378 6.61643 18.3187 6.54309 18.2762C6.46975 18.2338 6.4111 18.17 6.37497 18.0933C6.33884 18.0166 6.32694 17.9308 6.34087 17.8472L7.60254 10.7422",
    stroke: "#2563EB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.6641C13.2614 11.6641 15.5 9.42549 15.5 6.66406C15.5 3.90264 13.2614 1.66406 10.5 1.66406C7.73858 1.66406 5.5 3.90264 5.5 6.66406C5.5 9.42549 7.73858 11.6641 10.5 11.6641Z",
    stroke: "#2563EB",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertifications);
export default __webpack_public_path__ + "static/media/certifications.ff862b6e8f0e0db3eeeae49c5e475de2.svg";
export { ForwardRef as ReactComponent };